import React from 'react';
import { FLEX_ALIGN, FLEX_JUSTIFY, FlexBox } from '@monorepo/ui-kit';
import Column from '../Column';
import styles from './index.module.css';

const PersonalOffice: Component = ({ className = '', layout, components }) => {
  const { columns, type } = layout;

    return (
      <FlexBox
        className={`${styles.wrap} ${styles[type]}`}
        align={FLEX_ALIGN.start}
        justify={FLEX_JUSTIFY.center}
      >
        <div className={styles.grid}>
          <Column
            key={columns[0].join('/')}
            column={columns[0]}
            className={styles.column}
            components={components}
          />
          <Column
            key={columns[1].join('/')}
            column={columns[1]}
            className={styles.column}
            components={components}
          />
        </div>
      </FlexBox>
    );
};

export default PersonalOffice;
